document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-panel');

    function activateTab(index, updateHash = true) {
        contents.forEach(content => content.style.display = 'none');
        tabs.forEach(tab => tab.classList.remove('active'));

        contents[index].style.display = 'block';
        tabs[index].classList.add('active');

        if (updateHash) {
            const tabId = tabs[index].getAttribute('data-tab');
            history.replaceState(null, null, '#' + tabId);
        }
    }

    // Default: hide all
    contents.forEach(content => content.style.display = 'none');

    // Check URL hash on load
    const hash = window.location.hash.replace('#', '');
    let activeIndex = 0;

    tabs.forEach((tab, index) => {
        const tabId = tab.getAttribute('data-tab');

        if (tabId === hash) {
            activeIndex = index;
        }

        tab.addEventListener('click', () => {
            activateTab(index);
        });
    });

    activateTab(activeIndex, false);

    // Support back/forward browser navigation
    window.addEventListener('hashchange', () => {
        const newHash = window.location.hash.replace('#', '');
        tabs.forEach((tab, index) => {
            if (tab.getAttribute('data-tab') === newHash) {
                activateTab(index, false);
            }
        });
    });
});
